var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgrammingBrowserThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 65.25C5.55653 65.25 4.41193 64.7759 3.56802 63.932C2.72411 63.0881 2.25 61.9435 2.25 60.75V11.595C2.25396 10.3112 2.76568 9.0812 3.67344 8.17344C4.5812 7.26568 5.81124 6.75396 7.095 6.75H64.929C66.2064 6.75396 67.4303 7.26315 68.3336 8.16641C69.2369 9.06966 69.746 10.2936 69.75 11.571V60.405C69.746 61.6888 69.2343 62.9188 68.3266 63.8266C67.4188 64.7343 66.1888 65.246 64.905 65.25H6.75Z",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.75 20.25H2.25",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 33.75L58.5 42.75L49.5 51.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 33.75L13.5 42.75L22.5 51.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 33.75L31.5 51.75",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingBrowserThin);
export default __webpack_public_path__ + "static/media/programmingBrowserThin.ad47dbf8f598b31e79157ffeb1c664df.svg";
export { ForwardRef as ReactComponent };